import { render, staticRenderFns } from "./VChevron.vue?vue&type=template&id=f24c5b04&scoped=true&lang=pug&functional=true&"
import script from "./VChevron.vue?vue&type=script&lang=js&"
export * from "./VChevron.vue?vue&type=script&lang=js&"
import style0 from "./VChevron.vue?vue&type=style&index=0&id=f24c5b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "f24c5b04",
  null
  
)

export default component.exports